export function SlackIntegrationPage() {
    return <div>Slack Integration</div>;
}
